import { ContainerProps } from './types'

export function Container({
  children,
  className = '',
  ...props
}: ContainerProps) {
  return (
    <div
      className={`mx-auto w-full max-w-360 px-6 md:px-8 xl:px-12 ${className}`}
      {...props}
    >
      {children}
    </div>
  )
}
